import styled from 'styled-components/macro';
import { InputContainer } from '@yme/atoms/input';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { SpinnerLoaderMaskStyled } from '@yme/atoms/spinner-loader/styled';
import { SVGIconStyled } from '@yme/atoms/svg-icon';
import { Z_INDEX } from '@yme/tokens/zindex';
export const SingleInputFormStyled = styled.form `
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 0 0 100%;

  margin-bottom: 24px;

  // Rewrite styles for styled component - InputContainer
  ${InputContainer} {
    width: 100%;
  }

  // TODO: (D.K.) Need investigate this approach
  input {
    text-overflow: ellipsis;
    height: 44px;

    ${({ isRightToLeft }) => (isRightToLeft ? 'padding-left: 76px;' : 'padding-right: 76px;')}
  }
`;
export const ControlPanelStyled = styled.div `
  position: absolute;
  bottom: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 0 10px;
  z-index: ${Z_INDEX.level8};

  ${SVGIconStyled} {
    cursor: pointer;
  }

  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 0px; direction: rtl;' : 'right: 0px;')}
`;
export const SpinnerLoaderStyled = styled(SpinnerLoader) `
  ${SpinnerLoaderMaskStyled} {
    position: relative;
  }
`;
export const TargetWrapperStyled = styled.span ``;
